import React, { useEffect, useState } from "react";
import Footer from "../../../Footer";
import MenuBar from "../../../MenuBar";
import Header from "../../../Header";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import CustomButton from "../../../../reusableComponents/CustomButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../../context/API_Client";
import LoadingLogoPage from "../../../loadingPage/loadingPage";
import WebhookIcon from "@mui/icons-material/Webhook";
import ResponseModal from "./ResponseModal";
import ContentHeader from "../../../../reusableComponents/contentHeader/ContentHeader";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../../../constants/brandings";

const theme = createTheme({
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "var(--global-purple-900, #403E9F)",
          "&.Mui-checked": {
            color: "var(--global-purple-900, #403E9F)",
          },
        },
      },
    },
  },
});
export default function CreateWebhook() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("webhookId");
  const {
    createWebhook,
    postPspConfigForFiltering,
    updateWebhoookDetails,
    getSpecificIdWebhookDetails,
  } = useAuth();
  const [selectedItems, setSelectedItems] = useState([]);
  const [createdWebhook, setCreatedWebhook] = useState([]);
  const [specificWebhookData, setSpecificWebhookData] = useState({});
  const [selectedValue, setSelectedValue] = useState("true");
  const [loading, setLoading] = useState(true);
  const [endpointUrl, setEndpointUrl] = useState("");
  const [description, setDescription] = useState("");
  const [version, setVersion] = useState("");
  const [selectedFields, setSelectedFields] = useState([]);
  const [urlError, setUrlError] = useState("");
  const [open, setOpen] = useState(false);
  const [toNavigate, setToNavigate] = useState(false);
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+(\.[^ "]+)+(\/[^ "]+)*$/;
  const [isUrlValid, setIsUrlValid] = useState(true);

  const handleUrlChange = (e) => {
    const url = e.target.value;
    setEndpointUrl(url);

    // Validate URL using the regex pattern
    const isValid = urlRegex.test(url);

    // Set error message
    setUrlError(isValid ? "" : "Please enter correct URL");
  };
  const handleClose = () => {
    setOpen(false);
    customToast(
      "error",
      "high",
      `Webhook Config test failed. Please check your
    endpoint URL and retry again`
    );
  };
  useEffect(() => {
    postPspConfigForFiltering(
      {},
      function (data) {
        setSelectedFields(data?.operations);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  const handleCheckboxChange = (item) => {
    if (item === "Select All") {
      if (selectedItems?.length === selectedFields?.length) {
        setSelectedItems([]);
      } else {
        const allValues = selectedFields?.map((item) => item?.value);
        setSelectedItems(allValues);
      }
    } else {
      let updatedSelectedItems;

      if (selectedItems?.includes(item)) {
        updatedSelectedItems = selectedItems?.filter(
          (selected) => selected !== item
        );
      } else {
        updatedSelectedItems = [...selectedItems, item];
      }
      setSelectedItems(updatedSelectedItems);
    }
  };

  const handleSubmit = () => {
    createWebhook(
      {
        url: endpointUrl,
        enabled: selectedValue,
        description: description,
        events: selectedItems,
        type: "StatusNotification",
      },
      function (res) {
        if (res?.status == 202) setOpen(true);
        else {
          customToast("success", "high", `webhook configuration created`);

          setToNavigate(true);
        }
        setCreatedWebhook(res?.data);
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  useEffect(() => {
    if (Object.keys(createdWebhook)?.length > 0 && toNavigate) {
      navigate("/developers/webhooks", { state: createdWebhook });
      localStorage.setItem("webhookCreated", true);
    }
  }, [createdWebhook]);

  useEffect(() => {
    if (editId) {
      getSpecificIdWebhookDetails(
        editId,
        (data) => {
          setSpecificWebhookData(data);
          setVersion(data?.version);
        },
        (errorMsg) => {
          customToast("error", "high", errorMsg);
        }
      );
    }
  }, [editId]);

  useEffect(() => {
    if (Object.keys(specificWebhookData)?.length) {
      setEndpointUrl(specificWebhookData?.url);
      setSelectedValue(specificWebhookData?.enabled);
      setDescription(specificWebhookData?.description);
      setSelectedItems(specificWebhookData.events || []);
    } else if (specificWebhookData?.length === 0) {
      setSelectedValue("true");
    }
  }, [specificWebhookData]);

  useEffect(() => {
    if (Object.keys(specificWebhookData)?.length > 0) {
      setLoading(false);
    }
  }, [specificWebhookData]);

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const updateWebhookData = () => {
    updateWebhoookDetails(
      editId,
      {
        url: endpointUrl,
        enabled: selectedValue,
        description: description,
        events: selectedItems,
        type: "StatusNotification",
        version: version,
      },
      function (res) {
        if (res?.status == 202) {
          setOpen(true);
        } else {
          customToast("success", "high", `Webhook details updated`);

          if (res.data) {
            navigate("/developers/webhooks");
          }
        }
        setCreatedWebhook(res?.data);
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };
  return (
    <>
      {Object.keys(specificWebhookData)?.length && loading ? (
        <LoadingLogoPage />
      ) : (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            <div className="payment-link-main-div">
              <ContentHeader
                firstHeading={!editId ? "Create Webhook" : "Update Webhook"}
                secondHeading="Elevate efficiency by setting up webhooks effortlessly on our dashboard"
                icon={<WebhookIcon />}
              />
              <form>
                <div
                  style={{ width: "100%", marginTop: "32px", display: "flex" }}
                >
                  <div style={{ width: "60%" }}>
                    <Typography
                      className="labelRegular"
                      style={{
                        color: "var(--global-neutral-grey-1100, #2D2B32)",
                      }}
                    >
                      Endpoint URL*
                    </Typography>
                    <TextField
                      variant="outlined"
                      placeholder="Enter Url"
                      id="outlined-basic"
                      sx={{
                        borderRadius: "8px",
                        marginTop: "8px",
                        width: "100%",
                        height: "42px",
                      }}
                      size="small"
                      fullWidth
                      value={endpointUrl}
                      onChange={handleUrlChange}
                    />
                    {urlError?.length > 0 && endpointUrl?.length > 0 && (
                      <FormHelperText
                        error={!isUrlValid}
                        style={{
                          color: "#B9232F",
                          fontSize: "10px",
                          marginTop: "2px",
                        }}
                      >
                        <img
                          src="/assets/errorOutline.svg"
                          style={{ height: "12px", width: "12px" }}
                        />
                        {urlError}
                      </FormHelperText>
                    )}
                  </div>
                  <div style={{ width: "30%", marginLeft: "90px" }}>
                    <Typography
                      className="labelRegular"
                      style={{
                        color: "var(--global-neutral-grey-1100, #2D2B32)",
                      }}
                    >
                      Enabled
                    </Typography>

                    <div style={{ display: "flex", marginTop: "6px" }}>
                      <ThemeProvider theme={theme}>
                        <RadioGroup
                          row
                          value={selectedValue}
                          onChange={(e) => handleRadioChange(e)}
                        >
                          <FormControlLabel
                            className="radioLabels"
                            value="true"
                            control={<Radio color="default" />}
                            label={
                              <div
                                style={{
                                  color:
                                    "var(--global-neutral-grey-1300, #0A090B)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  fontFamily: "Poppins",
                                }}
                              >
                                Yes
                              </div>
                            }
                          />
                          <FormControlLabel
                            className="radioLabels"
                            value="false"
                            control={<Radio color="default" />}
                            label={
                              <div
                                style={{
                                  color:
                                    "var(--global-neutral-grey-1300, #0A090B)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  fontFamily: "Poppins",
                                }}
                              >
                                No
                              </div>
                            }
                          />
                        </RadioGroup>
                      </ThemeProvider>
                    </div>
                  </div>
                </div>
                <Box sx={{ mt: "28px" }}>
                  <Typography
                    htmlFor="description"
                    className="labelRegular"
                    style={{
                      color: "var(--global-neutral-grey-1100, #2D2B32)",
                    }}
                  >
                    Description
                  </Typography>

                  <OutlinedInput
                    multiline
                    rows={3}
                    size="small"
                    placeholder="Enter Description"
                    aria-describedby="outlined-name-helper-text"
                    sx={{ width: "60%", height: "80px", marginTop: "8px" }}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Box>
                <div
                  style={{
                    marginTop: "48px",
                    width: "100%",
                    borderRadius: "12px",
                    background: "var(--Neutral-2, #FAFAFA)",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      className="b1Regular"
                      style={{
                        color: "var(--global-neutral-grey-1200, #1D1C20)",
                      }}
                    >
                      Select events to listen to
                    </Typography>

                    {selectedFields?.length > 0 && (
                      <Grid item xs={12} sm={6} md={3}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          className="businessUnitCheckbox"
                          onClick={() => handleCheckboxChange("Select All")}
                        >
                          <Checkbox
                            className="checkbox"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                color: colorBrandObject?.secondaryButtonColor,
                              },
                              "&.Mui-checked": {
                                color: colorBrandObject?.secondaryButtonColor,
                                "& .MuiSvgIcon-root": {
                                  fill: colorBrandObject?.secondaryButtonColor,
                                },
                              },
                            }}
                            checked={
                              selectedItems?.length ===
                              selectedFields?.length &&
                              selectedItems?.length > 0
                            }
                          />
                          <Typography
                            className="labelSemiBold"
                            style={{
                              color: "var(--global-neutral-grey-1200, #1D1C20)",
                            }}
                          >
                            Select All
                          </Typography>
                        </div>
                      </Grid>
                    )}
                  </div>
                  <Grid container spacing={1}>
                    {selectedFields?.map((item, idx) => (
                      <Grid item xs={12} sm={6} md={3} key={idx}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "20px",
                            cursor: "pointer",
                          }}
                          className="businessUnitCheckbox"
                          onClick={() => handleCheckboxChange(item?.value)}
                        >
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                color: colorBrandObject?.secondaryButtonColor,
                              },
                              "&.Mui-checked": {
                                color: colorBrandObject?.secondaryButtonColor,
                                "& .MuiSvgIcon-root": {
                                  fill: colorBrandObject?.secondaryButtonColor,
                                },
                              },
                            }}
                            className="checkbox"
                            checked={selectedItems?.includes(item?.value)}
                          />
                          <Typography
                            className="labelSemiBold"
                            style={{
                              color: "var(--global-neutral-grey-1200, #1D1C20)",
                            }}
                          >
                            {item?.value}
                          </Typography>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: "24px",
                    }}
                  >
                    <CustomButton
                      text={"Cancel"}
                      type={"primary"}
                      variant={"outlined"}
                      size={"sm"}
                      onClick={() => navigate("/developers/webhooks")}
                    />
                    <div style={{ marginLeft: "12px" }}>
                      <CustomButton
                        text={!editId ? "Test & Save" : "Save Changes  "}
                        type={"primary"}
                        variant={"contained"}
                        size={"sm"}
                        disabled={
                          endpointUrl?.length == 0 || selectedItems?.length == 0
                        }
                        onClick={() => {
                          !editId ? handleSubmit() : updateWebhookData();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </div>
      )}
      <ResponseModal
        open={open}
        onClose={handleClose}
        createdWebhook={createdWebhook}
      />
    </>
  );
}
